<button mat-flat-button [disabled]="saving || disabled" color="primary" (click)="onClick()">
  <mat-icon *ngIf="saving">
    <mat-spinner color="accent" mode="indeterminate" [diameter]="20"></mat-spinner>
  </mat-icon>
  <ng-content></ng-content>
</button>
